<div class="formulario-derecha">
  <div class="back">
    <h2>
      {{
        (isEdit
          ? "notification_reminders.edit_title"
          : "notification_reminders.create_title"
        ) | translate
      }}
    </h2>
    <i class="icon-cross2" (click)="emitBack()"></i>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-3">
    <!-- Title -->
    <div class="mb-3">
      <label class="form-label"
        >{{ "notification_reminders.fields.title" | translate }} *</label
      >
      <input
        type="text"
        class="form-control"
        formControlName="title"
        placeholder="{{ 'notification_reminders.fields.title' | translate }}"
      />
    </div>

    <!-- Description -->
    <div class="mb-3">
      <label class="form-label">{{
        "notification_reminders.fields.description" | translate
      }}</label>
      <textarea
        class="form-control"
        formControlName="description"
        rows="3"
        placeholder="{{
          'notification_reminders.fields.description' | translate
        }}"
      ></textarea>
    </div>

    <!-- Channels -->
    <div class="mb-3">
      <label class="form-label"
        >{{ "notification_reminders.fields.channels" | translate }} *</label
      >
      <div class="d-flex gap-3">
        <div class="form-check" *ngFor="let ch of channelOptions">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="isChannelSelected(ch.value)"
            (change)="onChannelToggle(ch.value)"
            [id]="'channel-' + ch.value"
          />
          <label class="form-check-label" [for]="'channel-' + ch.value">
            <i
              [class]="ch.value === 'email' ? 'icon-envelope' : 'icon-bell2'"
              class="me-1"
            ></i>
            {{ ch.label | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- Target Users -->
    <div class="mb-3">
      <label class="form-label"
        >{{ "notification_reminders.fields.target_users" | translate }} *</label
      >
      <select class="form-control" (change)="addUser($event)">
        <option value="" selected disabled>
          {{ "notification_reminders.select_users" | translate }}
        </option>
        <option *ngFor="let user of availableUsers" [value]="user.reference">
          {{ user.fullName || user.name }}
        </option>
      </select>
      <div class="selected-users-container" *ngIf="selectedUsers.length">
        <span *ngFor="let user of selectedUsers" class="user-badge">
          <i class="icon-user me-1"></i>{{ user.fullName || user.name }}
          <i
            class="icon-cross remove-user"
            (click)="removeUser(user.reference)"
          ></i>
        </span>
      </div>
    </div>
  </form>
  <div class="div-form"></div>
  <div class="btn-send">
    <button
      type="submit"
      class="btn btn-primary btn-primary-form"
      (click)="onSubmit()"
    >
      {{ (isEdit ? "buttons.save" : "buttons.send") | translate }}
    </button>
  </div>
</div>
